/**
 * Tipos del módulo Manifiestos de guías
 */

export interface ManifiestoCarrierConfig {
  id: string
  label: string
  /** Valor de transportadora en API / arrays.js */
  transportadoraValue: string
  description?: string
  /** Clases Tailwind para icono (color de marca) */
  iconColorClass: string
  iconBgClass: string
  /** Alias normalizados para agrupar respuestas del API */
  aliases: string[]
}

export interface ManifiestoCarrierCount {
  carrierId: string
  count: number
  isLoading: boolean
  error: string | null
}

export interface ManifiestoDespachoRow {
  index: number
  orderId: number
  destinatario: string
  ciudad: string
  direccion: string
  contenido: string
  documento: string
  und: number
  peso: number
  vol: number
  decl: number
  declLabel: string
  flete: number
  fleteLabel: string
  guia: string
  ciudadCentro: string
}

export const MANIFIESTO_SOURCE_STATUS = 'en_zona_despacho'
export const MANIFIESTO_TARGET_STATUS = 'manifiesto_impreso'
